export default "__VITE_ASSET__hVVXZ86l__"